import { FC } from 'react';

const GDPRNotice: FC = () => {
    return (
        <span className="tw-text-sm">
            Yes, I have read and agree to TouchBistro's{' '}
            <a href="/privacy-notice/" className={'!tw-text-sm'} target="_blank">
                Privacy and Processing Policy
            </a>
            .
        </span>
    );
};

export default GDPRNotice;
